/**
 * Created by yqdong on 2018/3/18.
 * qq: 1013501639
 * @author yqdong
 *
 */
import { actions, apis, mutations } from '../constants'
import Store from '../Store'

export default function (ajax) {
  let store = new Store({
    state: {
      eventList: []
    },
    mutations: {
      [mutations.visualizer.setEventList] (state, list) {
        state.eventList = list
      },
      [mutations.visualizer.addEvent] (state, event) {
        state.eventList.push(event)
      },
      [mutations.visualizer.delEvent] (state, event) {
        // 状态是add的，直接删除
        if (event.status === 'add') {
          for (let i = 0; i < state.eventList.length; i++) {
            if (event === state.eventList[i]) {
              state.eventList.splice(i, 1)
              return
            }
          }
        } else { // 状态不是add的（保存在数据库中的）则标记状态为del
          for (let i = 0; i < state.eventList.length; i++) {
            if (event.device_type === 'Android') {
              if (event.id === state.eventList[i].id) {
                state.eventList[i].status = 'del'
              }
            } else {
              if (event.eventId === state.eventList[i].eventId) {
                state.eventList[i].eventJson.status = 'del'
                return
              }
            }
          }
        }
      },
      [mutations.visualizer.cancel] (state) {
        const delList = state.eventList.filter(item => {
          return item.status === 'add'
        })
        delList.forEach(item => {
          state.eventList.forEach((event, i) => {
            if (event === item) state.eventList.splice(i, 1)
          })
        })
        state.eventList.forEach((event) => {
          if (event.device_type === 'Android') {
            if (event.status === 'del') event.status = 'normal'
          } else {
            if (event.eventJson.status === 'del') event.eventJson.status = 'normal'
          }
        })
      }
    },
    actions: {
      [actions.visualizer.queryAndroidEvents] (context, data) {
        return new Promise((resolve, reject) => {
          store.setReady(context, 'eventList', false)
          ajax({
            url: apis.visualizer.queryAndroidEvents,
            method: 'post',
            data,
            transformRequest(params) {
              var arr = []
              for (let key in params) {
                arr.push(`${key}=${encodeURIComponent(params[key])}`)
              }
              return arr.join('&')
            }
          })
          .then(res => {
            if (!res.detail || !res.detail.payload || !res.detail.payload.events) {
              reject('返回结构错误')
              return
            }
            context.commit(mutations.visualizer.setEventList, res.detail.payload.events.map(item => {
              item.status = ''
              return item
            }))
            store.setReady(context, 'eventList', true)
            resolve()
          })
          .catch(reject)
        })
      },
      [actions.visualizer.queryEvents] (context, params) {
        return new Promise((resolve, reject) => {
          store.setReady(context, 'eventList', false)
          ajax({
            url: apis.visualizer.queryEvents,
            method: 'get',
            params
          })
          .then(res => {
            context.commit(mutations.visualizer.setEventList, res.event_infos.map(item => {
              item.eventJson = JSON.parse(item.eventJson)
              item.eventJson.status = ''
              return item
            }))
            store.setReady(context, 'eventList', true)
            resolve()
          })
          .catch(err => {
            console.error('获取事件列表失败', err)
            reject()
          })
        })
      },
      [actions.visualizer.applyEvents] (context, data) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.visualizer.applyEvents,
            method: 'post',
            data,
            transformRequest(params) {
              var arr = []
              for (let key in params) {
                arr.push(`${key}=${encodeURIComponent(params[key])}`)
              }
              return arr.join('&')
            }
          })
          .then(res => {
            resolve()
          })
          .catch(reject)
        })
      },
      [actions.visualizer.applyAllEvents] (context, data) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.visualizer.applyAllEvents,
            method: 'post',
            data: {
              data: JSON.stringify(data)
            },
            transformRequest(params) {
              var arr = []
              for (let key in params) {
                arr.push(`${key}=${encodeURIComponent(params[key])}`)
              }
              return arr.join('&')
            }
          })
          .then(res => {
            resolve()
          })
          .catch(reject)
        })
      },
      [actions.visualizer.removeEvents] (context, params) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.visualizer.queryEvents,
            method: 'delete',
            params
          })
          .then(res => {
            resolve()
          })
          .catch(reject)
        })
      },
      [actions.visualizer.checkEventName] (context, data) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.visualizer.checkEventName,
            method: 'post',
            data: {
              data: JSON.stringify(data)
            }
          })
          .then(res => {
            resolve(parseFloat(res.flag) > 0)
          })
          .catch(reject)
        })
      },
      [actions.visualizer.addEvent] (context, event) {
        context.commit(mutations.visualizer.addEvent, event)
      },
      [actions.visualizer.delEvent] (context, event) {
        context.commit(mutations.visualizer.delEvent, event)
      },
      [actions.visualizer.cancel] (context) {
        context.commit(mutations.visualizer.cancel, null)
      }
    }
  })
  return store
}
